import { render } from "./HelpTypeFieldset.vue?vue&type=template&id=5a230a7a"
import script from "./HelpTypeFieldset.vue?vue&type=script&lang=js"
export * from "./HelpTypeFieldset.vue?vue&type=script&lang=js"

import exportComponent from "/home/circleci/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__